<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Skrivarna M3250, MS622">
     Skrivarna M3250, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_sv" title="S&auml;kerhetsinformation">
     S&auml;kerhetsinformation
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Skrivs&auml;tt">
      Skrivs&auml;tt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Information om produkten">
      Information om produkten
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_sv" title="L&auml;r dig mer om skrivaren">
     L&auml;r dig mer om skrivaren
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_sv" title="Hitta information om skrivaren">
      Hitta information om skrivaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_sv" title="V&auml;lja en plats f&ouml;r skrivaren">
      V&auml;lja en plats f&ouml;r skrivaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_sv" title="Skrivarkonfigurationer">
      Skrivarkonfigurationer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_sv" title="Ansluta kablar">
      Ansluta kablar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_sv" title="Anv&auml;nda kontrollpanelen">
      Anv&auml;nda kontrollpanelen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sv" title="S&aring; h&auml;r anv&auml;nds statusarna p&aring; str&ouml;mknappen och indikatorlampan">
      S&aring; h&auml;r anv&auml;nds statusarna p&aring; str&ouml;mknappen och indikatorlampan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_sv" title="Skriva ut sidan f&ouml;r n&auml;tverksinst&auml;llningar">
      Skriva ut sidan f&ouml;r n&auml;tverksinst&auml;llningar
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sv" title="Konfigurera och anv&auml;nda programmen p&aring; huvudmenyn">
     Konfigurera och anv&auml;nda programmen p&aring; huvudmenyn
    </a>
   </p>
   <div id="divd0e748">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_sv" title="Anv&auml;nda startsk&auml;rmen">
      Anv&auml;nda startsk&auml;rmen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_sv" title="Anpassa startsk&auml;rmen">
      Anpassa startsk&auml;rmen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_sv" title="Anv&auml;nda Anpassning av visning">
      Anv&auml;nda Anpassning av visning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_sv" title="Konfigurera ekoinst&auml;llningar">
      Konfigurera ekoinst&auml;llningar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_sv" title="Anv&auml;nda kundsupport">
      Anv&auml;nda kundsupport
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_sv" title="Anv&auml;nda QR-kodgenerator">
      Anv&auml;nda QR-kodgenerator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_sv" title="Konfigurera enhetskvoter">
      Konfigurera enhetskvoter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_sv" title="Skapa en Cloud Connector-profil">
      Skapa en Cloud Connector-profil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1094" title="Hantera bokm&auml;rken">
      Hantera bokm&auml;rken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1171" title="Hantera kontakter">
      Hantera kontakter
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_sv" title="Konfigurera och anv&auml;nda tillg&auml;nglighetsfunktionerna">
     Konfigurera och anv&auml;nda tillg&auml;nglighetsfunktionerna
    </a>
   </p>
   <div id="divd0e1290">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_sv" title="Aktivera r&ouml;stv&auml;gledning">
      Aktivera r&ouml;stv&auml;gledning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_sv" title="Navigera p&aring; sk&auml;rmen med hj&auml;lp av gester">
      Navigera p&aring; sk&auml;rmen med hj&auml;lp av gester
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_sv" title="Aktivera f&ouml;rstoringsl&auml;ge">
      Aktivera f&ouml;rstoringsl&auml;ge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_sv" title="Justera talhastigheten f&ouml;r r&ouml;stv&auml;gledning">
      Justera talhastigheten f&ouml;r r&ouml;stv&auml;gledning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_sv" title="Anv&auml;nda tangentbordet p&aring; sk&auml;rmen">
      Anv&auml;nda tangentbordet p&aring; sk&auml;rmen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_sv" title="Aktivera talade l&ouml;senord och pin-koder">
      Aktivera talade l&ouml;senord och pin-koder
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_sv" title="Fylla p&aring; papper och specialmedia">
     Fylla p&aring; papper och specialmedia
    </a>
   </p>
   <div id="divd0e1495">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_sv" title="St&auml;lla in pappersstorlek och papperstyp">
      St&auml;lla in pappersstorlek och papperstyp
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_sv" title="Konfigurera universella pappersinst&auml;llningar">
      Konfigurera universella pappersinst&auml;llningar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_sv" title="Fylla p&aring; i magasin">
      Fylla p&aring; i magasin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_sv" title="Ladda universalarkmataren">
      Ladda universalarkmataren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_sv" title="L&auml;nka magasin">
      L&auml;nka magasin
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_sv" title="Pappersst&ouml;d">
     Pappersst&ouml;d
    </a>
   </p>
   <div id="divd0e1662">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_sv" title="Pappersstorlekar som kan anv&auml;ndas">
      Pappersstorlekar som kan anv&auml;ndas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_sv" title="Papperstyper som kan anv&auml;ndas">
      Papperstyper som kan anv&auml;ndas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_sv" title="Pappersvikter som kan anv&auml;ndas">
      Pappersvikter som kan anv&auml;ndas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_sv" title="Papper som inte kan anv&auml;ndas">
      Papper som inte kan anv&auml;ndas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_sv" title="Anv&auml;nda returpapper">
      Anv&auml;nda returpapper
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_sv" title="Skriva ut">
     Skriva ut
    </a>
   </p>
   <div id="divd0e2521">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_sv" title="Skriva ut fr&aring;n en dator">
      Skriva ut fr&aring;n en dator
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2547" title="Skriva ut fr&aring;n en mobil enhet">
      Skriva ut fr&aring;n en mobil enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_sv" title="Skriva ut fr&aring;n flashenhet">
      Skriva ut fr&aring;n flashenhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_sv" title="Flashenheter och filtyper som st&ouml;ds">
      Flashenheter och filtyper som st&ouml;ds
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sv" title="Konfigurera konfidentiella jobb">
      Konfigurera konfidentiella jobb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sv" title="Skriva ut konfidentiella jobb och andra stoppade jobb">
      Skriva ut konfidentiella jobb och andra stoppade jobb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_sv" title="Skriva ut fr&aring;n en Cloud Connector-profil">
      Skriva ut fr&aring;n en Cloud Connector-profil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_sv" title="Skriva ut en teckensnittslista">
      Skriva ut en teckensnittslista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_sv" title="Skriva ut en kataloglista">
      Skriva ut en kataloglista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_sv" title="Avbryta utskriftsjobb">
      Avbryta utskriftsjobb
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sv" title="F&ouml;rst&aring; skrivarmenyerna">
     F&ouml;rst&aring; skrivarmenyerna
    </a>
   </p>
   <div id="divd0e3057">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_sv" title="Meny&ouml;versikt">
      Meny&ouml;versikt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3376" title="Enhet">
      Enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5222" title="Skriv ut">
      Skriv ut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6480" title="Papper">
      Papper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6742" title="USB-enhet">
      USB-enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6963" title="N&auml;tverk/portar">
      N&auml;tverk/portar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8753" title="S&auml;kerhet">
      S&auml;kerhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9888" title="Rapporter">
      Rapporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_sv" title="Hj&auml;lp">
      Hj&auml;lp
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10136" title="Fels&ouml;kning">
      Fels&ouml;kning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_sv" title="Skriva ut en sida med menyinst&auml;llningar">
      Skriva ut en sida med menyinst&auml;llningar
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_sv" title="S&auml;kra skrivaren">
     S&auml;kra skrivaren
    </a>
   </p>
   <div id="divd0e10188">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_sv" title="Lokalisera s&auml;kerhetsplats">
      Lokalisera s&auml;kerhetsplats
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_sv" title="Radera skrivarminnet">
      Radera skrivarminnet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_sv" title="Rensa skrivarens h&aring;rddisk">
      Rensa skrivarens h&aring;rddisk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_sv" title="Kryptera skrivarens h&aring;rddisk">
      Kryptera skrivarens h&aring;rddisk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sv" title="&Aring;terst&auml;lla fabriksinst&auml;llningar">
      &Aring;terst&auml;lla fabriksinst&auml;llningar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_sv" title="Flyktighetsredog&ouml;relse">
      Flyktighetsredog&ouml;relse
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_sv" title="Underh&aring;lla skrivaren">
     Underh&aring;lla skrivaren
    </a>
   </p>
   <div id="divd0e10402">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sv" title="St&auml;lla in e-postaviseringar">
      St&auml;lla in e-postaviseringar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_sv" title="Justera standardvolym f&ouml;r h&ouml;rlurar">
      Justera standardvolym f&ouml;r h&ouml;rlurar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10464" title="N&auml;tverk">
      N&auml;tverk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_sv" title="Konfigurera seriell utskrift (endast Windows)">
      Konfigurera seriell utskrift (endast Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_sv" title="Reng&ouml;ra skrivaren">
      Reng&ouml;ra skrivaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_sv" title="Best&auml;lla delar och f&ouml;rbrukningsmaterial">
      Best&auml;lla delar och f&ouml;rbrukningsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11200" title="Byta ut delar och f&ouml;rbrukningsartiklar">
      Byta ut delar och f&ouml;rbrukningsartiklar
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11344" title="Flytta skrivaren">
      Flytta skrivaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11400" title="Spara energi och papper">
      Spara energi och papper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11504" title="&Aring;tervinning">
      &Aring;tervinning
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_sv" title="&Aring;tg&auml;rda pappersstopp">
     &Aring;tg&auml;rda pappersstopp
    </a>
   </p>
   <div id="divd0e11537">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_sv" title="Undvika pappersstopp">
      Undvika pappersstopp
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_sv" title="Hitta var papper har fastnat">
      Hitta var papper har fastnat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_sv" title="Pappersstopp i lucka A">
      Pappersstopp i lucka A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_sv" title="Pappersstopp i efterbehandlarens bakre lucka">
      Pappersstopp i efterbehandlarens bakre lucka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_sv" title="Pappersstopp i standardfacket">
      Pappersstopp i standardfacket
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_sv" title="Pappersstopp i enheten f&ouml;r dubbelsidig utskrift">
      Pappersstopp i enheten f&ouml;r dubbelsidig utskrift
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_sv" title="Pappersstopp i fack">
      Pappersstopp i fack
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_sv" title="Pappersstopp i universalarkmataren">
      Pappersstopp i universalarkmataren
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_sv" title="Fels&ouml;kning">
     Fels&ouml;kning
    </a>
   </p>
   <div id="divd0e11813">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11816" title="Problem med n&auml;tverksanslutningen">
      Problem med n&auml;tverksanslutningen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12130" title="Problem med maskinvarutillval">
      Problem med maskinvarutillval
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12404" title="Problem med f&ouml;rbrukningsmaterial">
      Problem med f&ouml;rbrukningsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_sv" title="Pappersmatningsproblem">
      Pappersmatningsproblem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_sv" title="Utskriftsproblem">
      Utskriftsproblem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sv" title="Kontakta kundsupport">
      Kontakta kundsupport
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_sv" title="Uppgradera och migrera">
     Uppgradera och migrera
    </a>
   </p>
   <div id="divd0e15396">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15399" title="Maskinvara">
      Maskinvara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15709" title="Programvara">
      Programvara
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15792" title="Fast programvara">
      Fast programvara
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_sv" title="Information">
     Information
    </a>
   </p>
   <div id="divd0e15879">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15882" title="Produktinformation">
      Produktinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15899" title="Om utg&aring;van">
      Om utg&aring;van
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_sv" title="Varum&auml;rken">
      Varum&auml;rken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_sv" title="Licensinformation">
      Licensinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_sv" title="Bullerni&aring;ver">
      Bullerni&aring;ver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_sv" title="WEEE-direktivet (Waste from Electrical and Electronic Equipment)">
      WEEE-direktivet (Waste from Electrical and Electronic Equipment)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16003" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_sv" title="Produktkassering">
      Produktkassering
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16037" title="Laddningsbart litiumjonbatteri">
      Laddningsbart litiumjonbatteri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_sv" title="F&ouml;rordning (EU) 2023/1542">
      F&ouml;rordning (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sv" title="L&auml;mna tillbaka Lexmark-kassetter f&ouml;r &aring;teranv&auml;ndning eller &aring;tervinning">
      L&auml;mna tillbaka Lexmark-kassetter f&ouml;r &aring;teranv&auml;ndning eller &aring;tervinning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_sv" title="Meddelande om statisk elektricitet">
      Meddelande om statisk elektricitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_sv" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_sv" title="Temperaturinformation">
      Temperaturinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_sv" title="Meddelande om laser">
      Meddelande om laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_sv" title="Str&ouml;mf&ouml;rbrukning">
      Str&ouml;mf&ouml;rbrukning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16277" title="Information om regler f&ouml;r tr&aring;dl&ouml;sa produkter">
      Information om regler f&ouml;r tr&aring;dl&ouml;sa produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_sv" title="Information om modul&auml;ra komponenter">
      Information om modul&auml;ra komponenter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_sv" title="Exponering f&ouml;r RF-str&aring;lning">
      Exponering f&ouml;r RF-str&aring;lning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16303" title="EU-regler">
      EU-regler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_sv" title="EU-regler">
      EU-regler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_sv" title="Om radiost&ouml;rningar">
      Om radiost&ouml;rningar
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue